import { render } from "./FarmosManage.vue?vue&type=template&id=054649c3"
import script from "./FarmosManage.vue?vue&type=script&lang=js"
export * from "./FarmosManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__